import "./App.css";
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Login from "./Pages/Login";
import Unauthorized from "./Unauthorized";
import AuthGuard from "./AuthGuard";
//import StudentDashboard from "./StudentComps/StudentDashboard";
//import TeacherDashboard from "./TeacherComps/TeacherDashboard";
//import CreateAssignment from "./TeacherComps/CreateAssignment";
import SignupPage from "./Pages/SignupPage";
import AdminMainPage from "./Pages/AdminMainPage";
import AdminDashBoard from "./AdminMainPageComps/AdminDashBoard";
import AdminOrdersMP from "./AdminMainPageComps/AdminOrdersMP";
import DeliveryMainPage from "./Pages/DeliveryMainPage";

//for local
//export const MyDomain = "https://localhost:44370/";
//for cloud
export const MyDomain =
  "https://makeup-manager.happymushroom-066fb8ce.westeurope.azurecontainerapps.io/";

function App() {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
      }}
    >
      <Switch>
        <Route exact path="/" component={Login} />
        <Route path="/unauthorized" component={Unauthorized} />
        <Route path="/signuppage" component={SignupPage} />
        {/* <Route
          path="/admin-mainpage/:admin-dashboard"
          component={AdminDashBoard}
        />
        <Route
          path="/admin-mainpage/:admin-orders-reports"
          component={AdminOrdersMP}
        /> */}

        {/* Protect Teacher Dashboard */}
        {/* <Route
          path="/admin-mainpage"
          render={(props) => (
            <AuthGuard allowedRoles={["Admin"]}>
              <AdminMainPage {...props} />
            </AuthGuard>
          )}
        /> */}
        <Route
          exact
          path="/admin-mainpage/:compname"
          render={({ match }) => (
            <AdminMainPage
              allowedRoles={["Admin"]}
              key={match.params.compname}
              compname={match.params.compname}
            />
          )}
        />
        <Route
          exact
          path="/delivery-mainpage/:compname"
          render={({ match }) => (
            <DeliveryMainPage
              allowedRoles={["Delivery"]}
              key={match.params.compname}
              compname={match.params.compname}
            />
          )}
        />

        {/* Protect Teacher Dashboard */}
        {/* <Route
          path="/create-assignment"
          render={({ match }) => (
            <AuthGuard allowedRoles={["Teacher"]}>
              <CreateAssignment key={match.params.CategoryName} />
            </AuthGuard>
          )}
        /> */}

        {/* Protect Student Dashboard */}
        {/* <Route
          path="/student-dashboard"
          render={(props) => (
            <AuthGuard allowedRoles={["Student"]}>
              <StudentDashboard {...props} />
            </AuthGuard>
          )}
        /> */}
      </Switch>
    </div>
  );
}

export default App;
